import { c as _c } from "react/compiler-runtime";
import SvgArrowdownFill from '@common/icon/SvgArrowdownFill';
import { cn } from '@core/utils';
import type { TrendKeywordItem } from './useTrendKeywords';
interface TrendRankChangeProps {
  rankChange: TrendKeywordItem['rankChange'];
  isNew: boolean;
  size: 'mobile' | 'desktop';
  upIconClassName?: string;
}
export const TrendRankChange = t0 => {
  const $ = _c(17);
  const {
    rankChange,
    isNew,
    size,
    upIconClassName
  } = t0;
  const typoClassName = size === "mobile" ? "typo-caption1 font-600" : "typo-caption2 font-600";
  if (isNew) {
    let t1;
    if ($[0] !== typoClassName) {
      t1 = cn("shrink-0 text-Gray-600", typoClassName);
      $[0] = typoClassName;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <span className={t1}>NEW</span>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (rankChange.label !== "UP" && rankChange.label !== "DOWN") {
    return null;
  }
  const isUp = rankChange.label === "UP";
  const iconSizeClassName = size === "mobile" ? "size-16" : "size-14";
  const t1 = isUp ? "+" : "-";
  let t2;
  if ($[4] !== rankChange.change || $[5] !== t1 || $[6] !== typoClassName) {
    t2 = <span className={typoClassName}>{t1}{rankChange.change}</span>;
    $[4] = rankChange.change;
    $[5] = t1;
    $[6] = typoClassName;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== iconSizeClassName || $[9] !== isUp || $[10] !== upIconClassName) {
    t3 = cn(iconSizeClassName, isUp && ["rotate-180", upIconClassName]);
    $[8] = iconSizeClassName;
    $[9] = isUp;
    $[10] = upIconClassName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <SvgArrowdownFill className={t3} />;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t4) {
    t5 = <span className="flex shrink-0 items-center gap-2 text-Gray-600">{t2}{t4}</span>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};